import React from "react";
import DownloadIcon from "../../../../svg/download-icon";

interface DownloadIconCellProps {
  value: {
    id: string;
    isEnabled: boolean;
    filePath?: string;
    fileName?: string;
  };
  onDownloadIconClick?: (filePath: string, fileName?: string) => void;
}

export const DownloadIconCell: React.FC<DownloadIconCellProps> = ({
  value,
  onDownloadIconClick,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (value.isEnabled && value.filePath && onDownloadIconClick) {
      onDownloadIconClick(value.filePath, value.fileName);
    }
  };

  return (
    <div
      className={`flex items-center justify-center ${
        value.isEnabled
          ? "cursor-pointer hover:opacity-80"
          : "cursor-not-allowed"
      }`}
      onClick={handleClick}
    >
      <DownloadIcon
        className={
          value.isEnabled ? "text-tertiaryBlue-4" : "text-primaryGray-15"
        }
      />
    </div>
  );
};

export default DownloadIconCell;
